import { render } from "./PersonInfoCard.vue?vue&type=template&id=260c12b5&scoped=true"
import script from "./PersonInfoCard.vue?vue&type=script&lang=js"
export * from "./PersonInfoCard.vue?vue&type=script&lang=js"

import "./PersonInfoCard.vue?vue&type=style&index=0&id=260c12b5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-260c12b5"]])

export default __exports__